export const APP_VERSION = 'v0.0.14';

export const CHANGELOG = [
  {
    version: 'v0.0.14',
    date: '11-11-2025',
    changes: [
      'Dark Mode Fixes: Leaderboard, Web Reports, Products, Create/Edit Teams, Web Scheduling, ',
      'Configurator: Added support for customizable form headers',
      'Added Docuseal tab to configurator',
      'Preset messages  for Review Requestsadded to customer-facing configurator',
      "User availablity modal on 'Me' page fixed",
      'Default product family added for Docuseal CRM',
      'Unsaved changes bug in configurator fixed',
      'imageList field updates in the configurator to choose a required number of photos within an imageList field',
      'Added ability to customize deal card in the configurator',
    ],
  },
  {
    version: 'v0.0.13',
    date: '10-07-2025',
    changes: [
      'Incentive Games: Added ability to create, update, and view incentive games',
      'Configurator: Added support for customizable form headers',
      'Configurator: Added deal card configuration',
      'Customer Configurator: Added customer-facing configurator for stages and dispositions',
      'Deals: Added video playback and upload support',
      'Games: Improved scroll behavior on the select rewards screen',
      'Web Area Map: Updated instructions background color from orange to green',
      'Bug fix: Fixed crash when opening deal metadata',
    ],
  },
  {
    version: 'v0.0.12',
    date: '09-19-2025',
    changes: [
      'Team Screen: fixed crash when trying to view a team member',
      'Team Screen: added recording consent form toggle',
      'Web Area Map: updated map area colors to match the mobile app',
      'Configurator: added recording auto start stop toggle',
      'Configurator: added docuseal visibility configuration',
      'Configurator: added webview type to flex field options in the form configuration',
    ],
  },
  {
    version: 'v0.0.11',
    date: '09-08-2025',
    changes: [
      'CS Dashboard: Added advanced filtering system for teams and individuals',
      'CS Dashboard: Implemented trends analytics with login tracking and user engagement metrics',
      'CS Dashboard: Added batch fetching for improved performance and reduced loading times',
      'CS Dashboard: Enhanced filtering to show only highest-level teams for better organization',
      'CS Dashboard: Added peak activity time analytics with improved error handling',
      'Reports: Added dark mode support for better accessibility',
      'Configurator: Added seat count management for capacity planning',
      'Bug fix: Resolved admin user crash when accessing media features',
      'Bug fix: Fixed team details screen access permissions issue',
      'Bug fix: Improved login rate calculations and percentage accuracy',
      'UI/UX: Added skeleton loading screens for trends and analytics',
      'UI/UX: Added unlimited and no expiration options for flexible time settings',
      'UI/UX: Enhanced permissions section consistency across platforms',
    ],
  },

  {
    version: 'v0.0.10',
    date: '08-19-2025',
    changes: [
      'Bracket Game: Scrolling behavior fixed in the contestant list',
      'Configurator: Missing part of the org object when saving erased some configuration settings',
      'Configurator: Updates for the damage reports feature in the configurator',
      'CS Dashboard: Updates to improve data fetching and added new metrics to CS dashboard',
    ],
  },
  {
    version: 'v0.0.9',
    date: '08-12-2025',
    changes: [
      'AI settings and prompt manager added to Paiv',
      'Games settings and improvements added to Paiv --- configurator change allowing only paiv admin to hide games and bracket games',
      'Fixed avatar profile picture glitching on the leaderboard',
      'Customer Service dashboard now available to admin-paiv',
      'Contact fields added to the configurator',
    ],
  },
  {
    version: 'v0.0.8',
    date: '07-30-2025',
    changes: [
      'Bracket Game: Round Name now auto-populates',
      'Bracket Game: Round state now initializes by copying settings from previous round',
      'Bracket Game: Round state now handles and copies rewards logic',
      'Bracket Game: Next Round scroll behavior on brackets improvements & dark mode fixes',
      'Bracket Game: Remove Rules on Brackets',
      'Bracket Game: Rewording of the Round Winner Reward',
      'Reward Selection screen fixes',
      'Add "all" option to the rewards filtering list',
      'Configurator: "Unknown" label now allows creating a Rule KPI',
      'Configurator: Add closerEqualsSetter option',
      'Configurator: Add showDispositionOnDealsList option',
      'Configurator: Add maxPinDistanceCheck option',
      'Locate deal button is now open in the map view always',
      "Bug fix: Deal uploaded PDF's are now being displayed",
      'Bug fix: Photos sync issue fixed on web and app',
      'Bug fix: Web Photos Fixes',
      'Bug fix: Leaderboard CSV download now downloads all pages of leaderboard kpi data',
      'Games: Goal Selection Behavior tweaks',
      'Archived rewards now show up as an option on Rewards page',
      'Deleting photos on web now reflects on the app',
    ],
  },
  {
    version: 'v0.0.7',
    date: '07-01-2025',
    changes: [
      'DocuSeal configuration ability added to the configurator',
      'Mapbox map & area creation feature now available on webapp for enabled orgs',
      'Label of form field in configurator now allows special characters',
      'Added Drone Instute pins option to configurator',
      'Fixed issue where "None" shows up on the roles that have roles',
      'Fix deal notes having dark text on dark mode',
      'Auto-generate formTabs when displayTabs is enabled in configurator',
      'No Order Lines Required for Signing option added to DocuSeal configuration',
      'MapBox fix: Browser list updated for production',
    ],
  },
  {
    version: 'v0.0.6',
    date: '06-05-2025',
    changes: [
      'Incentive games are now supported',
      'Feed name changed to correct name field for feed name',
      'Reordering disposition order in the configurator now pulls up save button',
    ],
  },
  {
    version: 'v0.0.5',
    date: '05-30-2025',
    changes: [
      'Leaderboard KPI Views & Filters added',
      "Creating a new product now doesn't require a category ID",
      "Creating a new team now doesn't require any members to be added",
      "Games starting or ending before today's date are now allowed to be added",
      'Negative coin amounts can now be subtracted from user coin total',
      'User can export and merge "hourly" report data',
    ],
  },
  {
    version: 'v0.0.4',
    date: '05-21-2025',
    changes: [
      'User Activity table now available for admin & manager users in Performance Tab',
      'Correct user icon now shows in Feed',
      'Clicking on user icon in Feed now takes you to the correct user profile',
      'Styling & functionality updates to the Games page',
      'SMS Notifications now can be added in the configurator',
      'KPI Leaderboard CSV download now downloads all pages of data, instead of just the first page',
      'Fix: Editing KPIs using the free text editor in the configurator now saves KPI id instead of title',
    ],
  },
  {
    version: 'v0.0.3',
    date: '05-12-2025',
    changes: [
      'Pagination added to the reporting & lambda fixed',
      'Parent disposition can now be added in the configurator',
      'Link to person and team profiles on game detail page fixed',
      "FeedItems with missing users are now filtered out in the feed so the page doesn't crash",
    ],
  },
  {
    version: 'v0.0.2',
    date: '04-29-2025',
    changes: [
      'Vimeo videos load on first render',
      'Fixed some styling on TrainingVideoPage to make the title of the video legible',
      'YouTube thumbnail & Vimeo thumbnails work',
      'Video / Documentation button in Training Materials Category fixed',
      "PDF Image thumbnail if there's no posterImage",
    ],
  },
  {
    version: 'v0.0.1',
    date: '04-23-2025',
    changes: [
      'PDF & Vimeo can be added to Training Media',
      'Added dark mode (currently only available for Admin Paiv)',
      'Added setStages and clearStages selectors in the configurator',
      'Invalid Disposition warning fixed in the configurator',
      'Warnings for deleted KPIs and Deal Stages added to Stage Mappings in the configurator',
      'Changes to match the current mobile implementation on Game list screen, Game details screen, and Game rules screen',
      'Added a changelog modal to the webapp',
      'Added a version number to the webapp',
    ],
  },
];
